export default {
  TOGGLE_LOADING: Symbol('TOGGLE_LOADING'),
  UPDATE_STATE: Symbol('UPDATE_STATE'),
  PRICE_MAP: Symbol('PRICE_MAP'),
  SET_BUSI_DATE: Symbol('SET_BUSI_DATE'),
  TOGGLE_PRICE_LOADING: Symbol('TOGGLE_PRICE_LOADING'),
};
